    // --- CURSOR ---
    const dot = document.getElementById('cursorDot');
    const ringEl = document.getElementById('cursorRing');
    let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;
    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.left = mouseX + 'px';
      dot.style.top = mouseY + 'px';
    });
    function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ringEl.style.left = ringX + 'px';
      ringEl.style.top = ringY + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    // --- THREE.JS Hero Particle Field ---
    const heroCanvas = document.getElementById('heroCanvas');
    if (heroCanvas) {
      const renderer = new THREE.WebGLRenderer({ canvas: heroCanvas, alpha: true });
      renderer.setSize(window.innerWidth, window.innerHeight);
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 100);
      camera.position.z = 12;
      const particleCount = 1000;
      const geometry = new THREE.BufferGeometry();
      const positions = new Float32Array(particleCount * 3);
      const colors = new Float32Array(particleCount * 3);
      const colorChoices = [
        new THREE.Color(0x0d9488),
        new THREE.Color(0xdb2777),
        new THREE.Color(0xeab308)
      ];
      for (let i = 0; i < particleCount; i++) {
        positions[i * 3] = (Math.random() - 0.5) * 35;
        positions[i * 3 + 1] = (Math.random() - 0.5) * 18;
        positions[i * 3 + 2] = (Math.random() - 0.5) * 15 - 10;
        const c = colorChoices[Math.floor(Math.random() * colorChoices.length)];
        colors[i * 3] = c.r; colors[i * 3 + 1] = c.g; colors[i * 3 + 2] = c.b;
      }
      geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
      geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
      const material = new THREE.PointsMaterial({ size: 0.055, transparent: true, opacity: 0.4, vertexColors: true });
      const points = new THREE.Points(geometry, material);
      scene.add(points);
      function animateParticles() {
        points.rotation.y += 0.0010;
        points.rotation.x += 0.0005;
        renderer.render(scene, camera);
        requestAnimationFrame(animateParticles);
      }
      animateParticles();
      window.addEventListener('resize', () => {
        renderer.setSize(window.innerWidth, window.innerHeight);
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
      });
    }

    // --- Showcase Canvas ---
    const showCanvas = document.getElementById('showcaseCanvas');
    if (showCanvas) {
      const sRenderer = new THREE.WebGLRenderer({ canvas: showCanvas, alpha: true });
      sRenderer.setSize(window.innerWidth, window.innerHeight);
      const sScene = new THREE.Scene();
      const sCamera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.1, 100);
      sCamera.position.z = 10;
      const starGeo = new THREE.BufferGeometry();
      const starPos = [];
      for (let i = 0; i < 800; i++) {
        starPos.push((Math.random() - 0.5) * 50, (Math.random() - 0.5) * 30, (Math.random() - 0.5) * 20);
      }
      starGeo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(starPos), 3));
      const starMat = new THREE.PointsMaterial({ color: 0x0d9488, size: 0.035, transparent: true, opacity: 0.3 });
      const stars = new THREE.Points(starGeo, starMat);
      sScene.add(stars);
      function animateStars() {
        stars.rotation.y += 0.0005;
        stars.rotation.x += 0.0003;
        sRenderer.render(sScene, sCamera);
        requestAnimationFrame(animateStars);
      }
      animateStars();
      window.addEventListener('resize', () => {
        sRenderer.setSize(window.innerWidth, window.innerHeight);
        sCamera.aspect = window.innerWidth / window.innerHeight;
        sCamera.updateProjectionMatrix();
      });
    }

    // --- GSAP ScrollTrigger ---
    gsap.registerPlugin(ScrollTrigger);
    document.querySelectorAll('.reveal-fade').forEach(el => {
      ScrollTrigger.create({
        trigger: el,
        start: "top 85%",
        onEnter: () => el.classList.add('visible'),
        once: true
      });
    });

    // Navbar hide on scroll down
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const nav = document.getElementById('navbar');
      const current = window.scrollY;
      if (current > lastScroll && current > 120) nav.style.transform = 'translateY(-100%)';
      else nav.style.transform = 'translateY(0)';
      lastScroll = current;
    });

    // --- GSAP Product Scroll Animation ---
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#main-canvas",
        start: "top top",
        end: "bottom bottom",
        scrub: 1,
      }
    });

    tl.to("#product", { scale: 0.9, duration: 1.2, ease: "power1.inOut" }, 0)
      .to("#bg-text", { opacity: 0.05, scale: 1.05, duration: 1.2 }, 0)
      .to("#features-wrapper", { opacity: 1, duration: 0.3 }, 0.2)
      .from("#features-wrapper", { rotation: -60, transformOrigin: "center center", duration: 1.5, ease: "power2.out" }, 0.2)
      .from(".feature-item", { rotation: 60, scale: 0, opacity: 0, stagger: 0.05, duration: 1.5, ease: "back.out(1.5)" }, 0.2)
      .to({}, { duration: 0.1 }); // Buffer at the end

    lucide.createIcons();
